module.exports = __webpack_public_path__ + "static/media/cosmina_hatmanu.a7bb9372.jpg";